import React, { useState, useEffect } from 'react'
import { Popup } from 'semantic-ui-react'
import PropTypes from "prop-types";
import { LocalActivity, LocalActivityOutlined } from '@material-ui/icons'
import moment from "moment";
import { dateFormat } from '../constants';

const ClubMemberIcon = ({ clubMemberDetails }) => {
    const [toolTipContent, setToolTipContent] = useState()
    useEffect(() => {
        setToolTipContent(clubMemberDetails)
    }, [clubMemberDetails])
    return <Popup
        disabled={!toolTipContent}
        content={toolTipContent &&
            <div
                style={{
                    alignItems: "center",
                    margin: "10px",
                }}>
                <p>{toolTipContent.Club?.Name}</p>
                <p>{toolTipContent.Description}</p>
                <p>{moment(toolTipContent.EnrollmentDate).format(dateFormat)} -{" "}
                   {moment(toolTipContent.EndDate).format(dateFormat)}
                </p>
            </div>
        }
        trigger={clubMemberDetails ? <LocalActivity style={{ color: 'green' }} /> : <LocalActivityOutlined />} />
}
ClubMemberIcon.propTypes = {
    clubMemberDetails: PropTypes.object
}
export default ClubMemberIcon
